import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Icon, Vacancies } from './style';

const VipCount = ({ total, marginBottom, fontSize }) => {
  return (
    <Wrapper marginBottom={marginBottom}>
      <Icon icon="star" size="13px" />

      <Vacancies fontSize={fontSize}>{total}</Vacancies>
    </Wrapper>
  );
};

VipCount.propTypes = {
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  marginBottom: PropTypes.number,
  fontSize: PropTypes.number,
};

export default VipCount;
